<template>
  <div class="page-wrap">
    <div class="page-container">


      <div class="btn-toolbar">
        <!-- 左侧按钮组 -->
        <div class="left-buttons">
          <el-button-group class="my-btn-group">
            <el-button plain size="mini" icon="el-icon-coin" class="btn-green"
              @click="changeProductImageFun()">添加产品主图</el-button>
          </el-button-group>
        </div>
      </div>

      <!-- 下方表格卡片 -->
      <div class="table-card">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="userName" label="创建人" width="80"> </el-table-column>
          <el-table-column prop="name" label="主图名称" width="180"> </el-table-column>
          <el-table-column prop="imgId" label="资源id"> </el-table-column>
          <el-table-column prop="imgMaterialId" label="素材id" width="180"> </el-table-column>
          <el-table-column prop="cicun" label="图片尺寸" width="100"> </el-table-column>
          <el-table-column label="产品主图" width="80">
            <template #default="scope">
              <img :src="scope.row.url" alt="" style="width: 50px;height: 50px;" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
          <el-table-column prop="regionRemark" label="操作" width="100">
            <template #default="scope">
              <el-button type="danger" @click="titledeleteFun2(scope)" icon="el-icon-delete" circle
                size="mini"></el-button>
            </template>

          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :currentPage="currentPage"></pagination>
      </div>
    </div>

    <!-- 添加产品主图弹窗控制 -->
    <el-dialog title="添加产品主图" v-model="productImageview" width="60%" class="dialog‑green">
      <el-form ref="formRef" :model="form" label-width="200px">
        <el-form-item label="产品主图名称:">
          <el-input v-model="form.name" placeholder="请输入产品主图名称" clearable style="width:520px"></el-input>
        </el-form-item>
        <el-form-item label="暂存广告主(源数据):">
          <el-input v-model="form.accountId" placeholder="请输入巨量账号id" clearable style="width:520px"></el-input>
        </el-form-item>
        <el-form-item label="产品主图">
          <el-upload class="avatar-uploader" :headers="{ authorize: token }"
            :action="uploadAction"
            :data="{ advertiserId: form.accountId }" :before-upload="beforeAvatarUpload" :on-success="(event, file, fileList) =>
              onSuccess(event, file, fileList, indexs)
              " multiple :show-file-list="false" :limit="50">
            <el-button size="small" type="success" round style="margin-right:20px">上传图片
            </el-button>
            <span>
              图片大小必须：<span style="color:red">jpg,png,jpeg等图片格式,宽高比1:1,大小≤1M,108*108≤尺寸≤108*108</span></span>
          </el-upload>
          <img v-if="form.url != ''" :src="form.url" alt="" style="width: 108px;height: 108px;" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="mini" @click="productMainImageaddFun()">添加产品主图</el-button>
          <el-button size="mini" @click="handleResetPackage()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 删除产品主图管理弹窗控制 -->
    <el-dialog v-model="deproductImageview" title="删除产品主图" width="30%">
      <el-form label-width="120px">
        <el-form-item>
          <font style="color:red">确定删除所选中的产品主图？</font>
        </el-form-item>
      </el-form>
      <el-form-item>
        <el-button type="primary" size="mini" @click="titledeleteFun()">确定删除</el-button>
        <el-button size="mini" @click="changedeproductImageviewFun()">取消</el-button>
      </el-form-item>
    </el-dialog>
  </div>
</template>

<script>
import { productMainImagelist, productMainImageadd, productMainImagedelete } from '@/request/new/ylyBatch'
import { baseURL } from '@/request/config'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件

export default {
  name: 'ylyProductImage',
  components: { pagination },
  setup() {
    const state = reactive({
      // 上传地址统一走 config.js，切换环境自动生效
      uploadAction: baseURL + '/r1/productMainImage/uploadProductImage',
      // 获取用户token
      token: 'Bearer' + localStorage.getItem('token'),
      //表格数据
      tableData: [],
      //选中的id
      sId: '',
      //产品主图重置数据
      restform: {
        name: '',
        accountId: '',
        imgMaterialId: '',
        imgId: '',
        url: '',
      },
      //添加产品主图的数据
      form: {
        name: '',
        accountId: '',
        imgMaterialId: '',
        imgId: '',
        url: '',
      },

      //添加产品主图开关
      productImageview: false,
      //添加产品主图开关控制
      changeProductImageFun: () => {
        state.productImageview = !state.productImageview
      },
      //删除产品主图
      deproductImageview: false,
      //删除产品主图开关控制
      changedeproductImageviewFun: () => {
        state.deproductImageview = !state.deproductImageview
      },
      //删除按钮
      titledeleteFun2: (scope) => {
        state.sId = scope.row.id
        state.changedeproductImageviewFun()
      },
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        productMainImagelistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        productMainImagelistFun()
      },
      //上传前检查填写账号id和图片是否有问题
      beforeAvatarUpload: (file) => {
        //1.格式校验
        const isImg = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
        //2.大小校验 ≤1M
        const isLt1M = file.size / 1024 / 1024 <= 1
        if (!isImg) {
          ElMessage.error('只能上传 jpg/png/jpeg 图片！')
          return false
        }
        if (!isLt1M) {
          ElMessage.error('图片大小不能超过1M！')
          return false
        }
        if (state.form.accountId == '') {
          ElMessage.error('请先填写暂存广告主(源数据)')
          return false
        }
      },
      // 上传图片成功返回信息
      onSuccess: (response, z, x, indexs) => {
        if (response.code == 200) {
          state.form.url = response.data.url
          state.form.imgId = response.data.imageId
          state.form.imgMaterialId = response.data.imgMaterialId
        } else {
          ElMessage.error(response.msg)
        }
      },
      //重置产品主图
      handleResetPackage: () => {
        // 深拷贝 restform，切断引用
        state.form = JSON.parse(JSON.stringify(state.restform))
      },
      //添加产品主图
      productMainImageaddFun: () => {
        if (state.form.url.length > 0 && state.form.name != '') {
          const datas = {
            imgMaterialId: state.form.imgMaterialId,
            imgId: state.form.imgId,
            url: state.form.url,
            name: state.form.name,
            accountId: state.form.accountId,
          }
          productMainImageadd(datas).then((res) => {
            if (res.code == 200) {
              ElMessage.success('添加成功')
              state.form = JSON.parse(JSON.stringify(state.restform))
              state.changeProductImageFun()
              productMainImagelistFun()
            }
          })
        } else {
          ElMessage.error('数据不能为空')
        }
      },
      //删除产品主图
      titledeleteFun: () => {
        const datas = {
          id: state.sId
        }
        productMainImagedelete(datas).then((res) => {
          console.log('删除产品主图', res)
          if (res.code == 200) {
            ElMessage.success('删除成功')
            state.changedeproductImageviewFun()
            productMainImagelistFun()
            state.sId = ''
          }

        })


      },



    })



    //分页查询当前登录用户的产品主图
    const productMainImagelistFun = () => {
      const datas = {
        packageName: state.packageName,
        title: state.title,
        currentPage: state.currentPage,
        size: state.pagesize,

      }
      productMainImagelist(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
      })
    }

    productMainImagelistFun()

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      productMainImagelistFun,
    }
  },

}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// 表格卡片
.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 8px 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  flex-shrink: 1;
  overflow-x: auto;
  padding-bottom: 4px;
}

// ========= ElementPlus 组件深度修改 现代UI 大圆角+hover平滑动画 =========
:deep() {

  // 输入框、选择器大圆角
  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);

    &:hover {
      border‑color: #b8c8e3;
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  // 按钮统一大圆角+平滑hover微交互
  .el-button {
    border‑radius: 12px !important;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);
    box‑shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box‑shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }

  // 表格样式美化，去掉生硬边框，圆角
  .el-table {
    border‑radius: 14px;
    overflow: hidden;
  }

  .el-table th.el-table__cell {
    background‑color: #f4f7fc !important;
  }

  .el-table__row:hover>td {
    background‑color: rgba(64, 158, 255, 0.04) !important;
  }

  // 弹窗 毛玻璃大圆角弥散阴影
  .modern-dialog.el-dialog {
    border‑radius: 20px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.78);
    backdrop‑filter: blur(16px);
    -webkit‑backdrop‑filter: blur(16px);
    box‑shadow: 0 12px 45px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .el-dialog__header {
    padding: 22px 26px 12px;
  }

  .el-dialog__body {
    padding: 10px 26px 22px;
  }

  // 分页组件圆角
  .el-pagination {

    .el-pager li,
    .el-pagination__btn {
      border‑radius: 10px;
    }
  }
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}
</style>